import Items from "../features/inventory/Items"

const InventoryItemsPage = () => {
    return (
        <>
        <Items />
        </>
    )
}
export default InventoryItemsPage